import React, { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'
import { useParams } from 'react-router-dom'

import { pageState } from 'Pages/AbTestWizard/recoil/state/page'
import { abTestState, sendingPreviewState } from './recoil/state/abtest'
import { initCallback, resetCallback } from './recoil/callbacks/callbacks'

import { Loading, Tooltip, ToastContainer } from 'mailup-web-components'
import Header from 'Pages/AbTestWizard/components/Header/Header'
import PageContainer from 'Components/PageContainer'
import ErrorFeedback from 'Components/ErrorFeedback'
import WizardContainer from 'Pages/AbTestWizard/components/WizardContainer'
import ModalConfirmLeave from 'Pages/AbTestWizard/components/ModalConfirmLeave'
import ModalColumnsManagement from './components/step3/ResultsPreview/ModalColumnsManagement'
import { ModalFilterDetails } from './components/step3/ModalFilterDetails'
import './AbTestWizard.scss'

const AbTestWizard = () => {
  const { loading, loaded, error, severity, showLoader } = useRecoilValue(
    pageState
  )
  const { showLoading } = useRecoilValue(sendingPreviewState)
  const { step1, step2, step3, step4 } = useRecoilValue(abTestState)

  // alert di uscita dalla pagina senza salvare
  useBeforeUnload(
    step1.step1IsDirty ||
      step2.step2IsDirty ||
      step3.step3IsDirty ||
      step4.step4IsDirty
  )

  const { id } = useParams()
  const init = useRecoilCallback(initCallback, [])
  const cleanup = useRecoilCallback(resetCallback, [])

  useEffect(() => {
    return () => {
      cleanup()
    }
  }, [])

  useEffect(() => {
    !loaded && init(id)
  }, [loaded])

  return (
    <>
      <Header />
      <Loading open={loading || showLoader || showLoading} />
      <Tooltip />
      <ModalConfirmLeave />
      <ModalColumnsManagement />
      <ModalFilterDetails />
      <ToastContainer />
      <PageContainer>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() => init(id)}
        />
        {!error && !loading && (
          <>
            <WizardContainer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default AbTestWizard
